/*
 * Content.jsx 10.01.2018
 *
 * (c) 2018 ergovia GmbH
 */

import React from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import {withStyles} from '@material-ui/core/styles';

import Authenticator from '../containers/core/Authenticator';
import ParticipantListFrameContainer from '../containers/participants/ParticipantListFrameContainer';
import ParticipantDetailControl from '../containers/detail/ParticipantDetailControls';

const styles = () => ({
    content: {
        height: '87vh',
        '@media (max-height: 885px)': {
            height: '86vh'
        },
        '@media (max-height: 805px)': {
            height: '84vh'
        },
        '@media (max-height: 700px)': {
            height: '80vh'
        },
        '@media (max-height: 600px)': {
            height: '77vh'
        },
        '@media (max-height: 520px)': {
            height: '75vh'
        },

        padding: '80px 0 0 0'
    }
});


/**
 * Komponente zur Darstellung von des Inhalts des Bildungsmanagers, also alles unter der Navigationsleiste
 */
class Content extends React.Component {

    constructor() {
        super();

        this.transformWidth = `@-webkit-keyframes transformWidth {
                                    0% {width: 70%;}
                                    100% {width: 100%;}
                                }`;
        this.transformWidthReverse = `@-webkit-keyframes transformWidthReverse {
                                            0% {width: 100%;}
                                            100% {width: 70%;}
                                      }`;
    }


    componentDidUpdate() {
        const styleSheet = document.styleSheets[0];
        styleSheet.insertRule(this.transformWidthReverse, styleSheet.cssRules.length);
    }

    render() {
        const styleSheet = document.styleSheets[0];
        styleSheet.insertRule(this.transformWidth, styleSheet.cssRules.length);

        const { classes } = this.props;

        return <Authenticator content={() =>
            <div className={classes.content}>
                <Router>
                    <div>
                        <Route exact path="/" component={ParticipantListFrameContainer} />
                        <Route path="/participant/:id/:goalId?" component={ParticipantDetailControl} />
                    </div>
                </Router>
            </div>
        }/>;
    }
}

export default withStyles(styles)(Content);



// WEBPACK FOOTER //
// ./src/de/ergovia/components/Content.jsx